import { render } from "./PlaylistEditComponent.vue?vue&type=template&id=4106dc64&scoped=true"
import script from "./PlaylistEditComponent.vue?vue&type=script&lang=js"
export * from "./PlaylistEditComponent.vue?vue&type=script&lang=js"

import "./PlaylistEditComponent.vue?vue&type=style&index=0&id=4106dc64&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4106dc64"]])

export default __exports__